import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=ed9d8ad8&"
import script from "./videoComponent.vue?vue&type=script&lang=js&"
export * from "./videoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed9d8ad8')) {
      api.createRecord('ed9d8ad8', component.options)
    } else {
      api.reload('ed9d8ad8', component.options)
    }
    module.hot.accept("./videoComponent.vue?vue&type=template&id=ed9d8ad8&", function () {
      api.rerender('ed9d8ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/video/videoComponent.vue"
export default component.exports